import {
    Plus,
    Workflow,
    AlertTriangle,
    UserPlus,
    Building,
    User,
    Users as UsersIcon,
} from 'lucide-react';
import type { GlobalCommand } from '../types';

/**
 * Action commands for Global Command Palette
 * Quick actions to create new entities
 * 
 * Note: These commands show alerts for now since we don't have
 * direct access to dialog states. In a real implementation,
 * you would use global state or events to open these dialogs.
 */
export function actionCommands(onClose: (open: boolean) => void): GlobalCommand[] {
    return [
        {
            id: 'action-new-workflow',
            title: 'New Workflow',
            shortcut: 'N W',
            icon: Workflow,
            group: 'actions',
            action: () => {
                // TODO: Implement dialog opening
                // For now, we'll use an event-based approach
                window.dispatchEvent(
                    new CustomEvent('openDialog', { detail: { type: 'workflow' } })
                );
                onClose(false);
            },
        },
        {
            id: 'action-new-incident',
            title: 'New Incident',
            shortcut: 'N I',
            icon: AlertTriangle,
            group: 'actions',
            action: () => {
                window.dispatchEvent(
                    new CustomEvent('openDialog', { detail: { type: 'incident' } })
                );
                onClose(false);
            },
        },
        {
            id: 'action-new-user',
            title: 'New User',
            shortcut: 'N U',
            icon: UserPlus,
            group: 'actions',
            action: () => {
                window.dispatchEvent(
                    new CustomEvent('openDialog', { detail: { type: 'user' } })
                );
                onClose(false);
            },
        },
        {
            id: 'action-new-company',
            title: 'New Company',
            shortcut: 'N C',
            icon: Building,
            group: 'actions',
            action: () => {
                window.dispatchEvent(
                    new CustomEvent('openDialog', { detail: { type: 'company' } })
                );
                onClose(false);
            },
        },
        {
            id: 'action-new-person',
            title: 'New Person',
            shortcut: 'N P',
            icon: User,
            group: 'actions',
            action: () => {
                window.dispatchEvent(
                    new CustomEvent('openDialog', { detail: { type: 'person' } })
                );
                onClose(false);
            },
        },
        {
            id: 'action-new-team',
            title: 'New Team',
            shortcut: 'N T',
            icon: UsersIcon,
            group: 'actions',
            action: () => {
                window.dispatchEvent(
                    new CustomEvent('openDialog', { detail: { type: 'team' } })
                );
                onClose(false);
            },
        },
    ];
}
